module.exports = __webpack_public_path__ + "/static/images/config.server.png";